import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

import { forkJoin } from "rxjs";
import * as _ from "lodash";

import { UserMasterService } from "../services/user-master.service";
import { DashboardService } from "../services/dashboard.service";
import { DashboardMyTaskService } from "../services/dashboardmytask.service";

@Injectable(
  { providedIn: 'root'}
  )
export class ActivatedTaskFromComplianceService {
  activatedTaskuserListforkJoin: any;
  activatedTaskCache: any;
  tempactivatedTask: any;
  userListCache: any;

  constructor(
    private http: HttpClient,
    private dashboardService: DashboardService,
    private userService: UserMasterService,
    private dashboardMyTaskService: DashboardMyTaskService
  ) {}

  getActivatedTasks(companyId): Promise<any> {
    let userList = this.userService.getUserList();

    let activatedTask = this.dashboardService.getActivatedTaskList(companyId);

    return forkJoin([activatedTask, userList])
      .toPromise()
      .then((res) => {
        this.activatedTaskuserListforkJoin = res;
        this.activatedTaskCache = res[0].taskList;
        this.userListCache = res[1].result;

        let activatedTaskforkJoin = res[0].taskList;
        let userListforkJoin = res[1].result;
       
        // AssignedTo , CreatedBy
        _.forEach(activatedTaskforkJoin, function (o) {
          var createdBy = _.filter(userListforkJoin, ["_id", o.CreatedBy]);

          if (createdBy.length) {
            _.assign(o, { Owner: createdBy[0].FirstName + " " + createdBy[0].LastName });
          } else {
            _.assign(o, { Owner: " " });
          }

          if (o.CategoryName == undefined) {
            
            _.assign(o, { CategoryName: "" });
          }
          if (o.ProcessName == undefined) {
           
            _.assign(o, { ProcessName: "" });
          }

          var assignedByID = o.AssignedTo;
          var assignedTo = _.filter(userListforkJoin, ["_id", o.AssignedTo[0]]);
           assignedTo.find(function (t) {
            o.AssignedTo = t.FirstName + " " + t.LastName;
            return false;
          });

          //test -- add status
          var complianceTaskStatus;
          if (o.TaskStatus == 1) complianceTaskStatus = "Pending";
          else if (o.TaskStatus == 2) complianceTaskStatus = "Completed";
          else if (o.TaskStatus == 3) complianceTaskStatus = "Delayed Completion";
          else if (o.TaskStatus == 4) complianceTaskStatus = "Partially Completed";
          else if (o.TaskStatus == 5) complianceTaskStatus = "NA";
          else if (o.TaskStatus == 6) complianceTaskStatus = "Done";
          else if (o.TaskStatus == 7) complianceTaskStatus = "Cancelled";

          if (o.TriggerStartDate > o.DueDate)
            _.assign(
              o,
              { LocalStatus: o.TaskStatus },
              { AssignedByID: assignedByID },
              { ActivatedTaskFromCompliance: true },
              { StartDate: o.DueDate },
              { EndDate: o.TriggerStartDate },
              { ComplianceTaskStatus: complianceTaskStatus }
            );
          else
            _.assign(
              o,
              { LocalStatus: o.TaskStatus },
              { AssignedByID: assignedByID },
              { ActivatedTaskFromCompliance: true },
              { StartDate: o.TriggerStartDate },
              { EndDate: o.DueDate },
              { ComplianceTaskStatus: complianceTaskStatus }
            );
  var assignedTo = _.filter(userListforkJoin, ["_id", o.AssignedTo[0]]);
        });

        this.tempactivatedTask = activatedTaskforkJoin;
       
        return this.tempactivatedTask;
      });

  }

  getMyActivatedTaskList(companyId, assignedTo) {
    let uniqueUserId = JSON.parse(localStorage.getItem("user")).UniqueUserId;
    var self = this;
    return this.dashboardMyTaskService
      .getUserIdbyUniqueUserId(uniqueUserId)
      .then((responseforUser) => {
     
        if (!responseforUser.status) {
          var promise = [this.userService.getUserList()];
          
          // Filter companies if specific companyId is provided
          let companiesToProcess = responseforUser.listOfId;
          if (companyId && companyId !== null && companyId !== undefined && companyId !== '') {
            // Filter to only the specified company
            companiesToProcess = _.filter(responseforUser.listOfId, function (company) {
              return String(company.CompanyId) === String(companyId);
            });
            
          } 
          
          for (var index = 0; index < companiesToProcess.length; index++) {
           
            promise.push(
              self.dashboardService.getMyActivatedTaskList(
                companiesToProcess[index].CompanyId,
                companiesToProcess[index]._id
              )
            );
          }
          return forkJoin(promise)
            .toPromise()
            .then((responseForMutipleActivatedTask) => {
             
              // Filter out error responses (status == 1) instead of returning early
              let validResponses = _.filter(responseForMutipleActivatedTask, function (element) {
                return element.status != 1 && element.status !== 1;
              });
              
              // Log any errors but continue processing
              let errorResponses = _.filter(responseForMutipleActivatedTask, function (element) {
                return element.status == 1 || element.status === 1;
              });
              
     
              if (validResponses.length > 0) {
                let userList = validResponses[0].result;
       
                // Remove userList from task responses
                let activatedTaskListResponse = validResponses.slice(1);
                let taskArray = [];
                let activatedTaskList = _.map(activatedTaskListResponse, function (element) {
                  // Check if element has taskList property
                  if (element && element.taskList && Array.isArray(element.taskList)) {
                    return _.concat(taskArray, element.taskList);
                  } else if (Array.isArray(element)) {
                    // If element is already an array of tasks
                    return _.concat(taskArray, element);
                  }
                  return taskArray;
                });
               
                activatedTaskList = _.flatten(activatedTaskList);
               
                _.forEach(activatedTaskList, function (element) {
                  var companyObject = _.find(responseforUser.listOfId, function (user) {
                    return user._id == _.get(element, "AssignedTo");
                  });
                 
                  if (companyObject) {
                    _.assign(element, { CompanyName: companyObject.CompanyName });
                  } else {
                    _.assign(element, { CompanyName: "" }); // Default value
                  }
                 
                  var createdBy = _.filter(userList, ["_id", _.get(element, "CreatedBy")]);
                  if (createdBy.length) {
                    _.assign(element, {
                      Owner: createdBy[0].FirstName + " " + createdBy[0].LastName,
                    });
                  } else {
                    _.assign(element, { Owner: " " });
                  }
 
                  if (_.get(element, "CategoryName") == undefined) {
                   
                    _.assign(element, { CategoryName: "" });
                  }
                  if (_.get(element, "ProcessName") == undefined) {
           
                    _.assign(element, { ProcessName: "" });
                  }
 
                  var assignedByID = _.get(element, "AssignedTo");
                  var assignedTo = _.filter(userList, ["_id", _.get(element, "AssignedTo")]);
                 
 
                  if (_.get(element, "TriggerStartDate") > _.get(element, "DueDate")) {
                    _.assign(
                      element,
                      { LocalStatus: _.get(element, "TaskStatus") },
                      { AssignedByID: assignedByID },
                      { ActivatedTaskFromCompliance: true },
                      { StartDate: _.get(element, "DueDate") },
                      { EndDate: _.get(element, "TriggerStartDate") }
                    );
                  } else {
                    _.assign(
                      element,
                      { LocalStatus: _.get(element, "TaskStatus") },
                      { AssignedByID: assignedByID },
                      { ActivatedTaskFromCompliance: true },
                      { StartDate: _.get(element, "TriggerStartDate") },
                      { EndDate: _.get(element, "DueDate") }
                    );
                  }
                });
                this.tempactivatedTask = activatedTaskList;
                return Promise.resolve(this.tempactivatedTask);
              } else {
                this.tempactivatedTask = [];
                return Promise.resolve(this.tempactivatedTask);
              }
            });
        }
      });
  }

  getactivatedTaskDetailsJsonData(taskId): Promise<any> {
    return this.http
      .get("/assets/localJson/activeTaskDetails.json")
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Error);
  }

  getComplianceTeamTaskList(rangeOfDate) {
    let uniqueUserId = JSON.parse(localStorage.getItem("user")).UniqueUserId;
    var self = this;
    return this.dashboardMyTaskService
      .getUserIdbyUniqueUserId(uniqueUserId)
      .then((responseforUser) => {
       
        if (!responseforUser.status) {
          var promise = [this.userService.getUserList()];
          for (var index = 0; index < responseforUser.listOfId.length; index++) {
            rangeOfDate.companyId = responseforUser.listOfId[index].CompanyId;
            rangeOfDate.userId = responseforUser.listOfId[index]._id;
            promise.push(self.dashboardService.getComplianceTeamTask(rangeOfDate));
          }
          return forkJoin(promise)
            .toPromise()
            .then((responseForMutipleActivatedTask) => {
              
              let errorObject = _.find(responseForMutipleActivatedTask, function (element) {
                return element.status == 1;
              });

              if (_.isNil(errorObject)) {
                let userList = responseForMutipleActivatedTask[0].result;
                let activatedTaskListResponse = responseForMutipleActivatedTask;
                activatedTaskListResponse.splice(0, 1);
                let taskArray = [];
                let activatedTaskList = _.map(activatedTaskListResponse, function (element) {
                  return _.concat(taskArray, element.taskList);
                });
                
                activatedTaskList = _.flatMapDeep(activatedTaskList);
              
                _.forEach(activatedTaskList, function (element) {
                  var createdBy = _.filter(userList, ["_id", _.get(element, "CreatedBy")]);
                  if (createdBy.length) {
                    _.assign(element, {
                      Owner: createdBy[0].FirstName + " " + createdBy[0].LastName,
                    });
                  } else {
                    _.assign(element, { Owner: " " });
                  }

                  if (_.get(element, "CategoryName") == undefined) {
                  
                    _.assign(element, { CategoryName: "" });
                  }
                  if (_.get(element, "ProcessName") == undefined) {
                
                    _.assign(element, { ProcessName: "" });
                  }

                  var assignedByID = _.get(element, "AssignedTo");
                  var assignedTo = _.filter(userList, ["_id", _.get(element, "AssignedTo")]);
                  
                  if (_.get(element, "TriggerStartDate") > _.get(element, "DueDate")) {
                    _.assign(
                      element,
                      { LocalStatus: _.get(element, "TaskStatus") },
                      { AssignedByID: assignedByID },
                      { ActivatedTaskFromCompliance: true },
                      { StartDate: _.get(element, "DueDate") },
                      { EndDate: _.get(element, "TriggerStartDate") }
                    );
                  } else {
                    _.assign(
                      element,
                      { LocalStatus: _.get(element, "TaskStatus") },
                      { AssignedByID: assignedByID },
                      { ActivatedTaskFromCompliance: true },
                      { StartDate: _.get(element, "TriggerStartDate") },
                      { EndDate: _.get(element, "DueDate") }
                    );
                  }
                });
                this.tempactivatedTask = activatedTaskList;
                return Promise.resolve(this.tempactivatedTask);
              }
            });
        }
      });
  }
}
